/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Done_Metric_Listings_UpdatedInputs */

const cs_import_done_metric_listings_updated = /** @type {(inputs: Import_Done_Metric_Listings_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemovitosti aktualizovány`)
};

const en_import_done_metric_listings_updated = /** @type {(inputs: Import_Done_Metric_Listings_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listings updated`)
};

/**
* | output |
* | --- |
* | "Listings updated" |
*
* @param {Import_Done_Metric_Listings_UpdatedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_done_metric_listings_updated = /** @type {((inputs?: Import_Done_Metric_Listings_UpdatedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Done_Metric_Listings_UpdatedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_done_metric_listings_updated(inputs)
	return cs_import_done_metric_listings_updated(inputs)
});